export default {
  entities: {
    comment: {
      commentsList: {
        title: 'Комментарии',
      },
    },
  },
};
